import { FilesCardQueryVariables, OrderByClause, SortOrder } from 'services';
import { create } from 'zustand';

type OrderByKey = 'recent' | 'oldest' | 'az' | 'za';

type Store = {
  activeFolderId?: string;
  rootFolderId?: string;
  orderByKey: OrderByKey;
  searchQuery: string;
  reset: () => void;
  setActiveFolderId: (folderId?: string, parentFolderId?: string) => void;
  setSearchQuery: (searchQuery: string) => void;
  setOrderBy: (orderBy: OrderByKey) => void;
};

export const useFilePickerStore = create<Store>()((set, get) => ({
  activeFolderId: undefined,
  rootFolderId: undefined,
  orderByKey: 'recent',
  searchQuery: '',
  reset: () => set({ activeFolderId: undefined }),
  setActiveFolderId: (folderId?: string, parentFolderId?: string) => {
    if (!get().rootFolderId) {
      set({ rootFolderId: parentFolderId });
    }
    set({ activeFolderId: folderId });
  },
  setOrderBy: (orderByKey: OrderByKey) => set({ orderByKey }),
  setSearchQuery: (searchQuery: string) => set({ searchQuery }),
}));

export const useActiveFolderId = () => useFilePickerStore((state) => state.activeFolderId);
export const useResetActiveFolderId = () => useFilePickerStore((state) => state.reset);
export const useSetActiveFolderId = () => useFilePickerStore((state) => state.setActiveFolderId);
export const useSetOrderBy = () => useFilePickerStore((state) => state.setOrderBy);
export const useOrderByKey = () => useFilePickerStore((state) => state.orderByKey);
export const useSearchQuery = () => useFilePickerStore((state) => state.searchQuery);
export const useSetSearchQuery = () => useFilePickerStore((state) => state.setSearchQuery);
export const useIsRootFolder = () =>
  useFilePickerStore((state) => {
    return (folderId?: string) => {
      if (!folderId) {
        return true;
      }
      return state.rootFolderId === folderId;
    };
  });

export const useInfiniteFilesVariables = (initialVariables: FilesCardQueryVariables) =>
  useFilePickerStore((state) => {
    let orderBy: OrderByClause[] = [{ column: 'created_at', order: SortOrder.Desc }];

    if (state.orderByKey === 'oldest') {
      orderBy = [{ column: 'created_at', order: SortOrder.Asc }];
    }
    if (state.orderByKey === 'az') {
      orderBy = [{ column: 'name', order: SortOrder.Asc }];
    }
    if (state.orderByKey === 'za') {
      orderBy = [{ column: 'name', order: SortOrder.Desc }];
    }

    const variables: FilesCardQueryVariables = {
      ...initialVariables,
      page: 1,
      is_filepicker: false,
      orderBy,
      folder_id: state.activeFolderId,
      keyword: state.searchQuery,
    };
    return variables;
  });
